import { Component, Input, OnInit } from '@angular/core';
import { SubductProperties } from '../../../state/edge.model';

@Component({
  selector: '[app-edge-duct-diagram-subduct]',
  templateUrl: './edge-duct-diagram-subduct.component.html'
})
export class EdgeDuctDiagramSubductComponent implements OnInit {

  @Input()
  cx: number;

  @Input()
  cy: number;

  @Input()
  r: number;

  @Input()
  i: number;

  @Input()
  subduct: SubductProperties;

  constructor() { }

  ngOnInit(): void {
    this.r = this.r || 18;
  }

}
